import { useEffect, useState } from "react";
import { safeLocalStorage } from "~/utils";

/**
 * Хук для сохранения состояния открытия аккордеона в localStorage.
 * @param key уникальный ключ для хранения состояния (например, "offerAccordionOpened")
 * @param initialOpen состояние по умолчанию, если ключ не найден
 */
export const usePersistentAccordion = (key: string, initialOpen = false) => {
	const [isOpen, setIsOpen] = useState(initialOpen);

	useEffect(() => {
		const saved = safeLocalStorage.getItem(key);
		if (saved === "true") {
			setIsOpen(true);
		}
	}, [key]);

	useEffect(() => {
		if (isOpen) {
			safeLocalStorage.setItem(key, "true");
		}
	}, [isOpen, key]);

	const open = () => setIsOpen(true);
	const close = () => setIsOpen(false);
	const toggle = () => setIsOpen((prev) => !prev);

	return { isOpen, setIsOpen, open, close, toggle };
};
